var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKanban(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.4V4.6C10.5 3.1 9.86 2.5 8.27 2.5H4.23C2.64 2.5 2 3.1 2 4.6V20.4C2 21.9 2.64 22.5 4.23 22.5H8.27C9.86 22.5 10.5 21.9 10.5 20.4Z",
    fill: "#2D5FA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22 13.4V4.6C22 3.1 21.36 2.5 19.77 2.5H15.73C14.14 2.5 13.5 3.1 13.5 4.6V13.4C13.5 14.9 14.14 15.5 15.73 15.5H19.77C21.36 15.5 22 14.9 22 13.4Z",
    fill: "#D74F58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanban);
export default __webpack_public_path__ + "static/media/kanban.7ce52864c75cee3646b534f68ae4d9ef.svg";
export { ForwardRef as ReactComponent };